<div
	class="app"
	role="presentation"
>
	<aside class="app__sidenav">
		<app-base-sidenav></app-base-sidenav>
	</aside>
	<main class="app__main">
		<section class="app__main-content">
			<router-outlet></router-outlet>
		</section>
	</main>
	<aside class="app__sidebar">
		<app-drawer></app-drawer>
	</aside>
</div>
<app-assertive-loader *ngIf="isLoading$ | async"></app-assertive-loader>
